module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: {
      robing: (_vm.list.status == 'is_close')
    },
    attrs: {
      "id": "robredbaglist"
    }
  }, [_c('div', {
    staticClass: "topView"
  }, [_c('div', {
    staticClass: "header",
    style: ('background-image:url(' + _vm.imgPath + 'redbag/redheader_03.png)')
  }, [_c('img', {
    staticClass: "close",
    attrs: {
      "src": _vm.imgPath + 'close.png'
    },
    on: {
      "click": _vm.close
    }
  }), _vm._v(" "), _c('img', {
    staticClass: "hb_headerImage",
    attrs: {
      "src": _vm.man.header
    }
  })]), _vm._v(" "), (_vm.list.status != 'is_close') ? [_c('p', {
    staticClass: "userNameLabel"
  }, [_vm._v(_vm._s(_vm.man.nick) + "的红包"), _c('span', {
    staticClass: "hb_ping"
  }, [_vm._v("拼")])]), _vm._v(" "), (_vm.list.amount) ? _c('div', {
    staticClass: "midContent"
  }, [(_vm.man.content) ? _c('p', {
    staticClass: "redtext"
  }, [_vm._v(_vm._s(_vm.man.content))]) : _c('p', {
    staticClass: "redtext"
  }, [_vm._v("恭喜发财，大吉大利")]), _vm._v(" "), _c('p', {
    staticClass: "redmoney"
  }, [_vm._v(_vm._s(_vm.list.amount)), _c('span', {
    staticClass: "yuan"
  }, [_vm._v("元")])]), _vm._v(" "), _c('p', {
    staticClass: "detail"
  }, [_vm._v("已存入零钱，可 "), _c('van-button', {
    attrs: {
      "type": "primary",
      "size": "mini"
    },
    on: {
      "click": _vm.cash
    }
  }, [_vm._v("提现")])], 1)]) : _c('p', {
    staticClass: "redtext"
  }, [_vm._v("手慢了,红包派完了")])] : _vm._e()], 2), _vm._v(" "), (_vm.list.status != 'is_close') ? _c('div', {
    staticClass: "lists"
  }, _vm._l((_vm.list.list), function(item, index) {
    return _c('div', {
      key: index,
      staticClass: "list-row clearfix"
    }, [_c('img', {
      attrs: {
        "src": item.header
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "redbag_box"
    }, [_c('span', {
      staticClass: "otherName"
    }, [_vm._v(_vm._s(item.nick))]), _vm._v(" "), _c('span', {
      staticClass: "other_money fr"
    }, [_vm._v(_vm._s(item.amount / 100) + " 元")]), _vm._v(" "), _c('p', {
      staticClass: "othertime"
    }, [_vm._v(_vm._s(item.create_time))])])])
  }), 0) : _c('div', {
    staticClass: "redbagBottom"
  }, [_c('p', {
    staticClass: "userNameLabel"
  }, [_vm._v(_vm._s(_vm.man.nick))]), _vm._v(" "), _c('p', {
    staticClass: "userNamebottomLabel"
  }), _vm._v(" "), _c('p', {
    staticClass: "userNamebottomLabel"
  }, [_vm._v("给你发了个红包")]), _vm._v(" "), (_vm.man.content) ? _c('p', {
    staticClass: "redtext"
  }, [_vm._v(_vm._s(_vm.man.conent))]) : _c('p', {
    staticClass: "redtext"
  }, [_vm._v("恭喜发财,大吉大利")]), _vm._v(" "), _c('i', {
    staticClass: "openimage",
    style: ('background-image:url(' + _vm.imgPath + 'redbag/open_10.png)'),
    on: {
      "click": _vm.openAction
    }
  }), _vm._v(" "), _c('i', {
    staticClass: "iconi-image",
    style: ('background-image:url(' + _vm.imgPath + 'redbag/redbottomImage_10.png)')
  })])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-35c0a265"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Modular/RobRedBagList.vue
// module id = 362
// module chunks = 0